
export class AddressViewModel implements IAddressViewModel {
  /** Address 1 */
  line1?: string | undefined;
  /** Address 2 */
  line2?: string | undefined;
  /** City/Suburb */
  suburb?: string | undefined;
  /** Postcode/Zip */
  postcode?: string | undefined;
  /** State/County */
  state?: string | undefined;
  countryCode?: string | undefined;
  locationDescription?: string | undefined;
  formattedLocation?: string | undefined;
  latitude?: string | undefined;
  longitude?: string | undefined;

  constructor(data?: IAddressViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.line1 = Data["line1"];
      this.line2 = Data["line2"];
      this.suburb = Data["suburb"];
      this.postcode = Data["postcode"];
      this.state = Data["state"];
      this.countryCode = Data["countryCode"];
      this.locationDescription = Data["locationDescription"];
      this.formattedLocation = Data["formattedLocation"];
      this.latitude = Data["latitude"];
      this.longitude = Data["longitude"];
    }
  }

  static fromJS(data: any): AddressViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new AddressViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["line1"] = this.line1;
    data["line2"] = this.line2;
    data["suburb"] = this.suburb;
    data["postcode"] = this.postcode;
    data["state"] = this.state;
    data["countryCode"] = this.countryCode;
    data["locationDescription"] = this.locationDescription;
    data["formattedLocation"] = this.formattedLocation;
    data["latitude"] = this.latitude;
    data["longitude"] = this.longitude;
    return data;
  }
}

export interface IAddressViewModel {
  /** Address 1 */
  line1?: string | undefined;
  /** Address 2 */
  line2?: string | undefined;
  /** City/Suburb */
  suburb?: string | undefined;
  /** Postcode/Zip */
  postcode?: string | undefined;
  /** State/County */
  state?: string | undefined;
  countryCode?: string | undefined;
  locationDescription?: string | undefined;
  formattedLocation?: string | undefined;
  latitude?: string | undefined;
  longitude?: string | undefined;
}